import styled from 'styled-components';

export const MobilePositionHeaderStyled = styled.div`
    text-align: center;

    h4 {
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 0;
    }

    .description {
        font-weight: 400;
        font-size: 14px;
        color: var(--color-white-60);
    }
`;
